/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Basicinformationaboutyourevent4Inputs */

const en_basicinformationaboutyourevent4 = /** @type {(inputs: Basicinformationaboutyourevent4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic information about your event`)
};

const de_basicinformationaboutyourevent4 = /** @type {(inputs: Basicinformationaboutyourevent4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Wichtigste zu deinem Event`)
};

/**
* | output |
* | --- |
* | "Basic information about your event" |
*
* @param {Basicinformationaboutyourevent4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const basicinformationaboutyourevent4 = /** @type {((inputs?: Basicinformationaboutyourevent4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Basicinformationaboutyourevent4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_basicinformationaboutyourevent4(inputs)
	return de_basicinformationaboutyourevent4(inputs)
});
export { basicinformationaboutyourevent4 as "basicInformationAboutYourEvent" }